import {
  COR_DIA_DISPONIBILIDADE,
  DESCRICAO_DIA_DISPONIBILIDADE,
} from '@/constants/status.constants';
import { formatarDataCompleta } from '@/helpers/formatacao.helpers';
import type { DiaDisponibilidade } from '@/types/status.types';

type BarraDisponibilidadeProps = {
  dias: DiaDisponibilidade[];
  janelaDias: number;
  disponibilidade: string;
  nomeServico: string;
};

/**
 * Faixa de quadradinhos com o histórico diário de um serviço.
 *
 * A faixa em si é decorativa para tecnologias assistivas: fazer um leitor de tela
 * percorrer noventa elementos dizendo "sem interrupções" é ruído, não informação. O
 * equivalente acessível é o resumo textual abaixo, que cita apenas os dias em que
 * houve ocorrência — que é o que alguém realmente quer saber.
 */
export const BarraDisponibilidade = ({
  dias,
  janelaDias,
  disponibilidade,
  nomeServico,
}: BarraDisponibilidadeProps) => {
  const comOcorrencia = dias.filter((dia) => dia.estado !== 'operacional');

  return (
    <>
      <div aria-hidden="true" className="mt-[11px] flex gap-px sm:gap-0.5">
        {dias.map((dia) => (
          <span
            key={dia.data}
            title={`${formatarDataCompleta(dia.data)} · ${DESCRICAO_DIA_DISPONIBILIDADE[dia.estado]}`}
            className="h-[26px] flex-1 rounded-[2px]"
            style={{ background: COR_DIA_DISPONIBILIDADE[dia.estado] }}
          />
        ))}
      </div>

      <p className="sr-only">
        {comOcorrencia.length === 0
          ? `${nomeServico}: sem ocorrências registradas nos últimos ${janelaDias} dias, ${disponibilidade} de disponibilidade.`
          : `${nomeServico}: ${disponibilidade} de disponibilidade nos últimos ${janelaDias} dias. Dias com ocorrência: ${comOcorrencia
              .map(
                (dia) =>
                  `${formatarDataCompleta(dia.data)}, ${DESCRICAO_DIA_DISPONIBILIDADE[dia.estado].toLowerCase()}`,
              )
              .join('; ')}.`}
      </p>

      <div
        aria-hidden="true"
        className="mt-1.5 flex justify-between text-[11px] text-muted-foreground"
      >
        <span>{janelaDias} dias atrás</span>
        <span className="font-semibold text-foreground">{disponibilidade}</span>
        <span>hoje</span>
      </div>
    </>
  );
};
